import {
  Component,
  EventEmitter,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { Column } from '../../simple-table/models/simple-table-model';
import { FormDialogComponent } from '../../form-dialog/form-dialog.component';
import { FormDialog } from 'src/app/shared/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Subject, filter, first, takeUntil } from 'rxjs';
import {
  ActionButton,
  ActionButtonActionType,
  ActionButtonType,
} from '../../../../shared/models/action-button.model';
import { MessageDialogComponent } from '../../message-dialog/message-dialog.component';

@Component({
  selector: 'app-widget-data-list',
  templateUrl: './widget-data-list.component.html',
  styleUrls: ['./widget-data-list.component.scss'],
})
export class WidgetDataListComponent implements OnDestroy, OnInit {
  readonly columns: InputSignal<Column[]> = input<Column[]>();
  readonly formControlRef: InputSignal<FormControl<any[]>> =
    input<FormControl<any[]>>();
  readonly formDialog: InputSignal<FormDialog> = input<FormDialog>();
  readonly actions: InputSignal<ActionButton[]> = input<ActionButton[]>([
    {
      name: 'Visualizar',
      icon: 'visibility',
      action: ActionButtonActionType.VIEW,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
    {
      name: 'Editar',
      icon: 'edit_note',
      action: ActionButtonActionType.EDIT,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
    {
      name: 'Deletar',
      icon: 'delete_outline',
      action: ActionButtonActionType.DELETE,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
  ]);

  readonly customModalRef: InputSignal<any> = input<any>();

  @Output()
  tableActions: EventEmitter<ActionButton> = new EventEmitter();

  @Output()
  dialogOpened: EventEmitter<void> = new EventEmitter();

  @Output()
  dialogClosed: EventEmitter<void> = new EventEmitter();

  private destroySubject: Subject<boolean> = new Subject();

  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  tableAction(action: ActionButton) {
    switch (action.action) {
      case ActionButtonActionType.EDIT:
        this.openEditDialog(action);
        break;
      case ActionButtonActionType.DELETE:
        this.openDeleteDialog(action);
        break;
      case ActionButtonActionType.VIEW:
        this.formDialog().formGroup.disable({ emitEvent: false });
        this.openEditDialog(action);
        break;
      default:
        this.tableActions.emit(action);
        break;
    }
  }

  openDialog(): MatDialogRef<FormDialogComponent, any> {
    const templateRef = this.customModalRef()
      ? this.customModalRef()
      : FormDialogComponent;
    return this.matDialog.open(templateRef, {
      minWidth: 500,
      data: this.formDialog,
    });
  }

  openNewItemDialog() {
    const dialogRef = this.openDialog();

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroySubject))
      .subscribe((value) => {
        if (value) {
          const controlValue = this.formControlRef().value || [];
          controlValue.push(value);
          this.formControlRef().setValue(controlValue);
        }

        this.dialogClosed.emit();
      });
  }

  openEditDialog(action: ActionButton) {
    this.formDialog().formGroup.patchValue(action.row, { emitEvent: false });
    const dialogRef = this.openDialog();

    dialogRef
      .afterOpened()
      .pipe(first())
      .subscribe(() => {
        this.dialogOpened.emit();
      });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroySubject))
      .subscribe((value) => {
        if (value) {
          const dataList = this.formControlRef().value;
          dataList[action.index] = value;
        }
        this.formDialog().formGroup.enable({ emitEvent: false });
        this.dialogClosed.emit();
      });
  }

  openDeleteDialog(action: ActionButton) {
    const dialogRef = this.matDialog.open(MessageDialogComponent, {
      minWidth: 500,
      data: {
        title: 'Confirmação',
        message: 'Deseja realmente remover esse item ?',
        icon: 'warning',
        iconColor: 'red',
        buttons: [
          {
            label: 'Cancelar',
            value: false,
          },
          {
            label: 'Confirmar',
            class: 'bg-primary-brand-color',
            color: 'primary',
            value: true,
          },
        ],
      },
    });

    dialogRef
      .afterClosed()
      .pipe(
        filter((value) => !!value),
        takeUntil(this.destroySubject)
      )
      .subscribe(() => {
        const dataList = this.formControlRef().value;
        dataList.splice(action.index, 1);
      });
  }
}
